/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useState } from 'react'
import { Column, useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table'
import moment from 'moment'
import clsx from 'clsx'
import { DatePicker } from 'antd'
import { useLayout } from '../../../../layout/core'
import { axiosClientAuth } from '../../../../../app/utils'
import { KTIcon } from '../../../../helpers'

type Props = {
  className?: string
  ticketData: any
  sendMessage?: any
}

const TablesWidgetTickets: React.FC<Props> = ({ className, ticketData, sendMessage }) => {
  const { setCurrentTicket } = useLayout()
  const [dateFilter, setDateFilter] = useState([])
  const [mData, setMData] = useState(ticketData)

  useEffect(() => {
    setMData(ticketData)
  }, [ticketData])


  const sendMessageFun = (item) => {
    axiosClientAuth
      .get('/support/tcil-ticket?ticket_uuid=' + item.uuid)
      .then((resp) => setCurrentTicket(resp.data.data))
      .catch(() => { })
  }

  const columns: ReadonlyArray<Column<any>> = useMemo(
    () => [
      {
        Header: 'S.No',
        id: 'serial-number',
        Cell: ({ row }) => row.index + 1,
      } as unknown as Column<any>,
      {
        id: 'DATE',
        Header: 'DATE',
        accessor: 'created_at',
        Cell: ({ ...props }) => {
          return (
            <>
              <span>{moment(props.value).format('DD/MM/YYYY')}</span>
              <span className='d-block text-muted fw-semibold'>
                {moment(props.value).format('LT')}
              </span>
            </>
          )
        },
      },
      {
        Header: 'Type',
        accessor: 'type',
        Cell: ({ row }) => {
          return (
            <>
              <span>{row.original.created_by?.pe_id ? "PE" : row.original.created_by?.is_vendor ? "TM" : "Admin"}</span>
            </>
          )
        },
      },
      {
        Header: 'Ticket ID',
        accessor: 'ticket_id',
        Cell: ({ row }) => {
          return (
            <>
              <span>{row.original.ticket_id}</span>
            </>
          )
        },
      },
      {
        Header: 'PE/TM ID',
        accessor: 'created_by',
        Cell: ({ ...props }) => {
          return (
            <>
              <span>{props.value?.pe_id || props.value?.vendor_id || props.value?.email}</span>
            </>
          )
        },
      },
      {
        Header: 'Name',
        accessor: 'title',
        Cell: ({ ...props }) => {
          return (
            <>
              <span>{props.value}</span>
            </>
          )
        },
      },
      {
        Header: 'Description',
        accessor: 'description',
        Cell: ({ ...props }) => {
          return (
            <>
              <span>{props.value}</span>
            </>
          )
        },
      },
      {
        Header: 'Status',
        accessor: 'status',
        Cell: ({ ...props }) => {
          return (
            <>
              {props.value == 'open' ? (
                <span className='badge badge-danger my-1'>Open</span>
              ) : props.value == 'resolved' ? (
                <span className='badge badge-success text-light my-1'>Resolved</span>
              ) : (
                <span className='badge badge-warning my-1'>Processing</span>
              )}
            </>
          )
        },
      },
      {
        Header: 'ACTION',
        accessor: 'uuid',
        Cell: ({ ...props }) => {
          return (
            <div className='w-200px d-flex gap-2 flex-wrap'>
              <button
                className='btn h-35px btn-icon btn btn-secondary px-10 w-200px'
                onClick={() => setCurrentTicket(props.row.original)}
                id='kt_drawer_ticket_detail_toggle'
              >
                View Details
              </button>
              <button
                className='btn h-35px btn-icon btn btn-primary px-10 w-200px'
                onClick={() => sendMessageFun(props.row.original)}
                id='kt_drawer_chat_toggle'
              >
                Send Message
              </button>
            </div>
          )
        },
      },
    ],
    []
  )

  const ipTable = useTable(
    {
      columns,
      data: mData,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  const { RangePicker } = DatePicker

  const onDateChange = (_, val) => {
    setDateFilter(val)
    if (val.length > 0 && val[0] != '') {
      setMData(
        ticketData.filter((item) => {
          const routeDate = moment(new Date(item?.created_at)).format('DD-MM-YYYY')
          const startDate = moment(new Date(val[0])).format('DD-MM-YYYY')
          const endDate = moment(new Date(val[1])).format('DD-MM-YYYY')

          return routeDate >= startDate && routeDate <= endDate
        })
      )
    } else {
      setMData(ticketData)
    }
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Tickets</span>
          <span className='text-muted fw-semibold fs-7'>Total {ticketData?.length} Tickets</span>
        </h3>
        <div className='d-flex align-items-center'>
          <RangePicker
            className='bg-secondary-custom text-white border-0 me-2'
            style={{ height: '35px' }}
            onChange={onDateChange}
            disabledDate={(current) => {
              return current && current.valueOf() > Date.now();
            }}
          />
          {/* <select
            className='form-select form-select-sm form-select-solid w-auto'
            value={ipTable?.headers[3].filterValue}
            onChange={(e) => ipTable?.headers[3].setFilter(e.target.value)}
          >
            {['All', 'whitelist', 'blacklist'].map((item) => (
              <option value={item == 'All' ? '' : item}>{item}</option>
            ))}
          </select> */}
          <div className='d-flex align-items-center position-relative my-1 ms-2'>
            <KTIcon iconName='magnifier' className='text-white-500 position-absolute ms-2' />
            <input
              type='text'
              id='kt_filter_search'
              className='form-control form-control-solid form-select-sm w-150px ps-9'
              placeholder='Search'
              value={ipTable?.state.globalFilter}
              onChange={(e) => ipTable?.setGlobalFilter(e.target.value)}
            />
          </div>
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      <div className='card-body pt-3'>
        <div className='table-responsive'>
          <table
            {...ipTable?.getTableProps()}
            className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
          >
            <thead>
              {ipTable?.headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th
                      className={column.render('Header') == 'ACTION' ? 'w-200px' : ''}
                      {...column.getHeaderProps(column.getSortByToggleProps())}
                    >
                      <span className='text-gray-400 fs-7'>{column.render('Header')}</span>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <KTIcon iconName='down' className='text-gray ms-1' />
                        ) : (
                          <KTIcon iconName='up' className='text-gray ms-1' />
                        )
                      ) : (
                        ''
                      )}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...ipTable?.getTableBodyProps()}>
              {(ipTable?.page.length > 0 &&
                ipTable?.page.map((row) => {
                  ipTable?.prepareRow(row)
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map((cell) => (
                        <td className='fw-bold' {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </td>
                      ))}
                    </tr>
                  )
                })) || (
                  <tr>
                    <td colSpan={7} className='text-center'>
                      <span className='fw-bold'>No data found.</span>
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
          <div className='d-flex justify-content-between align-items-center mt-5'>
            <div>
              <select
                className='form-select form-select-sm form-select-solid'
                value={ipTable?.state.pageSize}
                onChange={(e) => ipTable?.setPageSize(parseInt(e.target.value))}
              >
                {[10, 25, 50, 100].map((item) => (
                  <option key={item} value={item}>{item}</option>
                ))}
              </select>
            </div>
            <div>
              <span>
                Page{' '}
                <strong>
                  {ipTable?.state.pageIndex + 1} of {ipTable?.pageOptions.length}
                </strong>
              </span>
            </div>
            <div>
              <button
                className='btn btn-sm'
                onClick={() => ipTable?.previousPage()}
                disabled={!ipTable?.canPreviousPage}
              >
                <KTIcon iconName='left' className='text-gray fs-1 me-5' />
              </button>
              <button
                className='btn btn-sm'
                onClick={() => ipTable?.nextPage()}
                disabled={!ipTable?.canNextPage}
              >
                <KTIcon iconName='right' className='text-gray fs-1 me-5' />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export { TablesWidgetTickets }
